import announcement from './announcement';

export default {
    announcement,
};
